var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0677 0.395386C12.4557 0.395386 10.9086 1.1458 9.89872 2.33166C8.88892 1.1458 7.34176 0.395386 5.72975 0.395386C2.87629 0.395386 0.634277 2.63738 0.634277 5.49084C0.634277 8.99282 3.78419 11.8463 8.55541 16.1821L9.89872 17.3957L11.2421 16.1728C16.0133 11.8463 19.1632 8.99282 19.1632 5.49084C19.1632 2.63738 16.9212 0.395386 14.0677 0.395386ZM9.99142 14.8017L9.89872 14.8943L9.80612 14.8017C5.39621 10.8087 2.48718 8.16828 2.48718 5.49084C2.48718 3.63795 3.87685 2.24828 5.72975 2.24828C7.15647 2.24828 8.54614 3.16546 9.03716 4.43469H10.7696C11.2513 3.16546 12.641 2.24828 14.0677 2.24828C15.9206 2.24828 17.3103 3.63795 17.3103 5.49084C17.3103 8.16828 14.4013 10.8087 9.99142 14.8017Z",
    fill: "url(#svg-grad)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-grad",
    x1: 0.634278,
    y1: 17.3957,
    x2: 18.4269,
    y2: -0.343182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0854,
    className: "start-color"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    className: "end-color"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.dddafba471f2456a8e7f2d2b00a0437b.svg";
export { ForwardRef as ReactComponent };